import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const OtolaryngologyEntIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.5 40C79.5 61.8153 61.8153 79.5 40 79.5C18.1848 79.5 0.5 61.8153 0.5 40C0.5 18.1848 18.1848 0.5 40 0.5C61.8153 0.5 79.5 18.1848 79.5 40Z'
    />
    <path
      d='M55.069 65.0001H37.8276V59.8276H49.8966C52.7533 59.8276 55.069 62.1434 55.069 65.0001Z'
      fill='#F0915A'
    />
    <path
      d='M49.8968 59.8276H29.2071C25.3983 59.8276 22.3105 56.7399 22.3105 52.931V33.9655C22.3105 23.4912 30.8017 15 41.2761 15H43.0002C53.4746 15 61.9657 23.4912 61.9657 33.9655V44.3899C61.9657 48.1987 58.878 51.2864 55.0692 51.2864V65C55.0692 62.1433 52.7534 59.8276 49.8968 59.8276Z'
      fill='#FAB991'
    />
    <path
      d='M20.2884 46.0345H22.3103V35.6897C19.9298 35.6897 18 37.6195 18 40V43.7462C18 45.01 19.0246 46.0345 20.2884 46.0345Z'
      fill='#FAB991'
    />
    <path
      d='M29.2071 37.4138C24.446 37.4138 20.5864 41.2734 20.5864 46.0345H42.5692C43.2833 46.0345 43.8623 46.6135 43.8623 47.3276C43.8623 48.0417 43.2833 48.6207 42.5692 48.6207H22.3106V52.9311H36.9657C40.7746 52.9311 43.8623 56.0188 43.8623 59.8276V65H49.0347V49.4828C49.0347 42.8173 43.6313 37.4138 36.9657 37.4138H29.2071Z'
      fill='#F05A4B'
    />
    <path
      d='M46.4481 45.1723C51.6853 45.1723 55.9308 40.9267 55.9308 35.6895C55.9308 30.4524 51.6853 26.2068 46.4481 26.2068C41.2109 26.2068 36.9653 30.4524 36.9653 35.6895C36.9653 40.9267 41.2109 45.1723 46.4481 45.1723Z'
      fill='#D73728'
    />
    <path
      d='M46.4483 27.0689C51.2094 27.0689 55.069 30.9285 55.069 35.6896C55.069 40.4507 51.2094 44.3102 46.4483 44.3102C41.6872 44.3102 37.8277 40.4507 37.8277 35.6896C37.8277 30.9285 41.6872 27.0689 46.4483 27.0689ZM46.4483 25.3447C40.7441 25.3447 36.1035 29.9854 36.1035 35.6896C36.1035 41.3938 40.7441 46.0344 46.4483 46.0344C52.1525 46.0344 56.7932 41.3938 56.7932 35.6896C56.7932 29.9854 52.1524 25.3447 46.4483 25.3447Z'
      fill='#F05A4B'
    />
    <path
      d='M47.2216 28.794C44.3856 28.8413 42.1377 31.2143 42.1377 34.0507V39.138C42.1377 40.5664 43.2956 41.7242 44.7239 41.7242C46.1522 41.7242 47.3101 40.5664 47.3101 39.138C50.1668 39.138 52.4825 36.8223 52.4825 33.9656C52.4825 31.0795 50.1188 28.7456 47.2216 28.794Z'
      fill='#FAB991'
    />
    <path
      d='M47.3105 30.5173L47.2509 30.5178C45.4103 30.5485 43.9087 32.0873 43.8644 33.9656H44.2933C45.0075 33.9656 45.5864 34.5446 45.5864 35.2587C45.5864 35.9728 45.0075 36.5518 44.2933 36.5518H43.8623V39.1075C43.8623 39.5663 44.2077 39.9674 44.6653 39.998C45.1673 40.0317 45.5864 39.6329 45.5864 39.138V39.0693C45.5864 38.155 46.3276 37.4139 47.2418 37.4139C49.0966 37.4139 50.7162 35.899 50.7579 34.0447C50.8016 32.1073 49.2383 30.5173 47.3105 30.5173Z'
      fill='#F0915A'
    />
  </svg>
));
OtolaryngologyEntIcon.displayName = 'OtolaryngologyEntIcon';

export default OtolaryngologyEntIcon;
